const formatHoursCount = (value) => {
  const num = parseFloat(value || 0);
  return new Intl.NumberFormat("nb-NO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(num);
};

export const LaborSettlementDetails = ({
  labor,
  t,
  formatCurrency,
  translationPrefix = "accounting.project_summary",
}) => {
  if (!labor) return null;

  const hoursCount = parseFloat(labor.hours_count || 0);
  const unpaidHours = parseFloat(labor.unpaid_hours_count || 0);
  const unpaidAmount = parseFloat(labor.estimated_unpaid_amount || 0);
  const paidVoucher = parseFloat(
    labor.paid_via_voucher_amount ?? labor.voucher_based ?? 0
  );

  return (
    <div className="space-y-1">
      {unpaidHours > 0 && (
        <p className="text-amber-700 font-medium text-xs">
          {t(`${translationPrefix}.labor_unpaid_badge`, {
            hours: formatHoursCount(unpaidHours),
            amount: formatCurrency(unpaidAmount),
          })}
        </p>
      )}
      {paidVoucher !== 0 && (
        <p className="text-emerald-700 font-medium text-xs">
          {t(`${translationPrefix}.labor_paid_badge`, {
            amount: formatCurrency(paidVoucher),
          })}
        </p>
      )}
      <p className="text-xs text-gray-500">
        {t(`${translationPrefix}.labor_source_label`, {
          source:
            labor.source === "mixed" ? t(`${translationPrefix}.labor_source_mixed`) : labor.source === "voucher"
              ? t(`${translationPrefix}.labor_source_voucher`)
              : t(`${translationPrefix}.labor_source_hours`),
        })}
      </p>
      <p className="text-xs text-gray-500">
        {t(`${translationPrefix}.labor_hours_count`, {
          hours: formatHoursCount(hoursCount),
        })}
        {" · "}
        {t(`${translationPrefix}.labor_hours_estimate`)}:{" "}
        {formatCurrency(labor.hours_based || 0)}
        {" · "}
        {t(`${translationPrefix}.labor_voucher`)}:{" "}
        {formatCurrency(labor.voucher_based || 0)}
      </p>
    </div>
  );
};
